"use client";

import dynamic from "next/dynamic";
import SquareShimmer from "@/components/ui/shimmerUi/SquareShimmer";

/**
 * Client-only dynamic wrapper around `TrustedCrouselMain`.
 *
 * Why this exists:
 *  - `TrustedCrouselMain` brings in Swiper + the video carousel runtime — a
 *    significant chunk of client JS (~50-80 KB gzipped) used in a section that
 *    lives below the LCP fold on every page that renders `TrustedVoiceIndex`.
 *  - Wrapping it in `dynamic({ ssr: false })` from a tiny client boundary
 *    splits that runtime into a separate chunk that is fetched/parsed AFTER
 *    initial hydration, dropping the parent route's initial script-evaluation
 *    cost without touching the SSR'd heading/subtitle in `TrustedVoiceIndex`.
 *
 * The shimmer reserves space close to the carousel's final height to keep CLS
 * negligible on slow networks.
 */
const TrustedCrouselMain = dynamic(() => import("./TrustedCrouselMain"), {
  ssr: false,
  loading: () => (
    <div className="h-[480px] md:h-[620px] w-full">
      <SquareShimmer />
    </div>
  ),
});

export default TrustedCrouselMain;
